import { ApplicationRef, Component, ComponentRef, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
})
export class ConfirmComponent implements OnInit {
  constructor(private appRef: ApplicationRef) {}

  componentRef: ComponentRef<ConfirmComponent>;

  @ViewChild('childModal', { static: true }) public childModal: ModalDirective;

  confirmCallback: () => void;
  cancelCallback: () => void;
  message: string;
  messageHtml: string;
  header: string;
  confirmBtnText: string;

  ngOnInit() {
    this.childModal.onHidden.subscribe(x => {
      if (x.dismissReason === 'esc' || x.dismissReason === 'backdrop-click') {
        this.cancel();
      }
    });
  }

  destroy() {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
    }
  }

  show(options: {
    header?: string;
    message?: string;
    messageHtml?: string;
    confirmBtnText?: string;
    confirmed?: () => void;
    canceled?: () => void;
  }) {
    this.confirmCallback = options.confirmed;
    this.cancelCallback = options.canceled;
    this.header = options.header;
    this.message = options.message;
    this.messageHtml = options.messageHtml;
    this.confirmBtnText = options.confirmBtnText || 'Confirm';
    setTimeout(() => {
      this.childModal.show();
    }, 0);
  }

  confirm() {
    this.childModal.hide();
    this.destroy();
    this.confirmCallback && this.confirmCallback();
  }

  cancel() {
    this.childModal.hide();
    this.destroy();
    this.cancelCallback && this.cancelCallback();
  }
}
